import * as React from 'react'
import { Button } from 'react-bootstrap'

interface AddMoreArticlesButtonProps {
	addArticle: (e: any) => void
}

const AddMoreArticlesButton: React.FunctionComponent<AddMoreArticlesButtonProps> = (props) => {
	return (
		<Button
			id="generateAdGroup"
			bsStyle="success"
			onClick={props.addArticle}
			style={{ backgroundColor: '#4f4f4e', borderColor: '#4f4f4e' }}
		>
			Add More Articles
		</Button>
	)
}

export default AddMoreArticlesButton
